import React, { useState } from 'react';
import useScrollLock from '../../hooks/useScrollLock';
import './Salon.css';

// Long free-text table cells (Reason, Review Note) truncate to one line with an ellipsis;
// clicking opens the full text in a small dialog rather than distorting the row by
// expanding inline. `label` is used as the dialog title (e.g. "Reason", "Review Note").
const TruncatedText = ({ text, label }) => {
  const [isOpen, setIsOpen] = useState(false);
  useScrollLock(isOpen);

  if (!text) return '—';

  return (
    <>
      <span className="truncated-text" onClick={() => setIsOpen(true)} title={text}>
        {text}
      </span>
      {isOpen && (
        <div className="modal-overlay" onClick={() => setIsOpen(false)}>
          <div className="modal" style={{ maxWidth: '480px' }} onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>{label}</h3>
              <button type="button" className="modal-close" onClick={() => setIsOpen(false)}>×</button>
            </div>
            <div className="modal-body">
              <p style={{ whiteSpace: 'pre-wrap' }}>{text}</p>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default TruncatedText;
